import { ApplicationError } from "@/error";
import { captureExceptionWithContext } from "@/sentry";

export function handleError(error) {
  if (error.isAxiosError) {
    const config = error.config;
    const context = {
      request: {
        url: config.baseURL + config.url,
        correlationId: config.headers["correlation-id"],
        timeout: config.timeout,
      },
    };
    void captureExceptionWithContext(error, context);
  } else if (error instanceof ApplicationError) {
    void captureExceptionWithContext(error, error.contexts);
  } else {
    void captureExceptionWithContext(error);
  }
}
